module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Verbindung.eee6c946.jpg";